import React from 'react';
import Utility from '../../utils/Utility';

const PlayerMidControls = ({ style }) => Utility.getActivityIndicator(style);

export default PlayerMidControls;
